import { BrowserRouter, Routes, Route } from "react-router-dom"

import Home from "./pages/Home"
import CompanyLogin from "./pages/CompanyLogin"
import CompanyRegistration from "./pages/CompanyRegistration"
import ForgotPassword from "./pages/ForgotPassword"
import UserProfile from "./pages/UserProfile" // Added UserProfile import

import CompanyLayout from "./layouts/CompanyLayout"
import CompanySite from "./pages/CompanySite"
import Contact from "./pages/Contact"
import SearchResultCargo from "./pages/SearchResultCargo"
import SearchResultPaasenger from "./pages/SearchResultPaasenger"
import SearchResultVehicle from "./pages/SearchResultVehicle"
import WhoAreWe from "./pages/WhoAreWe"
import ContactSystem from "./pages/ContactSystem"
import UserLogin from "./pages/UserLogin"
import UserSignup from "./pages/UserSignup"
import SaleteamLogin from "./pages/SaleteamLogin"
import SaleteamForgotPassword from "./pages/SaleteamForgotPassword"
import ProtectedRoute from "./components/ProtectedRoute" // Import ProtectedRoute component

// Clean token parameter from URL synchronously before rendering starts
if (typeof window !== "undefined") {
  const params = new URLSearchParams(window.location.search)
  const tokenFromUrl = params.get("token")
  if (tokenFromUrl) {
    console.log("[v0] Synchronously capturing token and replacing history")
    localStorage.setItem("companyAuthToken", tokenFromUrl)
    localStorage.removeItem("authToken")
    params.delete("token")
    const newSearch = params.toString()
    const newPath = window.location.pathname + (newSearch ? `?${newSearch}` : "")
    window.history.replaceState({}, document.title, newPath)
  }
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
       <Route path="/" element={<Home />} />
        <Route path="/company-login" element={<CompanyLogin />} />
        <Route path="/company-registration" element={<CompanyRegistration />} />
        <Route path="/contacts" element={<ContactSystem />} />
        <Route path="/saleteam-login" element={<SaleteamLogin />} />
        <Route path="/saleteam-forgot-password" element={<SaleteamForgotPassword />} />
        {/* 🔥 Company routes (companyName auto picked) */}
        <Route path="/:companyName" element={<CompanyLayout />}>
          <Route index element={<CompanySite />} />
          <Route
            path="login"
            element={
              <ProtectedRoute requireAuth={false}>
                <UserLogin />
              </ProtectedRoute>
            }
          />
          <Route
            path="signup"
            element={
              <ProtectedRoute requireAuth={false}>
                <UserSignup />
              </ProtectedRoute>
            }
          />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="who-are-we" element={<WhoAreWe />} />
          <Route path="contact" element={<Contact />} />
          <Route path="search-result-cargo" element={<SearchResultCargo />} />
          <Route path="search-result-passenger" element={<SearchResultPaasenger />} />
          <Route path="search-result-vehicle" element={<SearchResultVehicle />} />
          <Route
            path="profile"
            element={
              <ProtectedRoute requireAuth={true}>
                <UserProfile />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
